import { render, staticRenderFns } from "./resource-toolbar.vue?vue&type=template&id=bd8fd9d6"
import script from "./resource-toolbar.vue?vue&type=script&lang=js"
export * from "./resource-toolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports